

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      totales: {
        discountAmount: 0,
        discountamountArg: 0,
        settlementTaxRI: 0,
        settlementTaxRNI: 0,
      },
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate(),
      }

    };
  },
  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis='+window.sssdi+'&a=liquidDet' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta

    }
  },
  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      "orderCellsTop": true,
      "fixedHeader": true


    });
    $('.box').boxWidget();

    //this.consultar();

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();


      this.totales.discountAmount = 0.0;
      this.totales.discountamountArg = 0.0;
      this.totales.settlementTaxRI = 0.0;
      this.totales.settlementTaxRNI = 0.0;


      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'liquidDet',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {


            for (let i = 0; i < response.data.data.length; i++) {



              this.totales.discountAmount += parseFloat(response.data.data[i][7]);
              this.totales.discountamountArg += parseFloat(response.data.data[i][8]);
              this.totales.settlementTaxRI += parseFloat(response.data.data[i][9]);
              this.totales.settlementTaxRNI += parseFloat(response.data.data[i][10]);



              for (let d = 9; d < response.data.data[i].length - 1; d++) 
              
                {
                 
                  response.data.data[i][d] = this.num_to_many(response.data.data[i][d]);
                 
                }
              

              response.data.data[i].push('<button disabled type="button" class="btn btn-default">Detalle</button>');
              this.tbv.row.add(response.data.data[i]);

            }


            this.totales.discountAmount = this.num_to_many(this.totales.discountAmount.toFixed(2));
            this.totales.discountamountArg = this.num_to_many(this.totales.discountamountArg.toFixed(2));
            this.totales.settlementTaxRI = this.num_to_many(this.totales.settlementTaxRI.toFixed(2));
            this.totales.settlementTaxRNI = this.num_to_many(this.totales.settlementTaxRNI.toFixed(2));



          }

          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionesDet/tventas/tventas.js